// eslint-disable-next-line no-restricted-globals
export const isDevelopment = location.origin !== "https://nostrifizierung.imc.ac.at"
export const API_BASE_URL = isDevelopment
    ? "https://localhost:62121"
    : "https://api.fh-krems.ac.at/nostrify";
export const API_ACTIVATE_URL = `${API_BASE_URL}/activate`;
export const API_REGISTER_URL = `${API_BASE_URL}/register`;
export const API_AUTHENTICATE_URL = `${API_BASE_URL}/authenticate`;